import React from 'react';
import { Translations } from '../../../utils/';
import './styles.css';

export default class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      showOptions: false,
      showCreateEntity: false,
      selectedOptionValue: '',
      selectedOption: '',
      setValue: false
    }
  }

  componentDidMount() {
    this.setState({ selectedOptionValue: this.props.selectedOptionValue || "" });
    this.props.selectedOptionValue ? this.props.setInputvalue(this.props.selectedOptionValue, this.props.id) : '';
    // if(this.props.mandatory === "true") {
    // if (this.props.selectedOptionValue !== "") {
    //   this.props.setFieldValidtionState(this.props.id, 'valid');
    //   }else{
    //     this.props.setFieldValidtionState(this.props.id, 'invalid');
    //   }
    // }
  }

  // life cycle hook
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleBackspace)
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang !== undefined ? this.props.lang.currentLang.lang : this.props.lang, this.props.lang.translatedData || this.props.translatedData)
  }

  handleBackspace = (e) => {
    if (e.keyCode === 8) {
      e.preventDefault();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.options !== undefined) {
      this.setState({ options: nextProps.options })
    }
    if (nextProps.showOptions !== undefined) {
      this.setState({ showOptions: nextProps.showOptions[nextProps.id] })
    }
    if (nextProps.selectedOptionValue !== undefined && nextProps.selectedOptionValue !== this.props.selectedOptionValue) {
      this.setState({ selectedOptionValue: nextProps.selectedOptionValue })
      if (this.state.setValue !== true) {
        this.props.setInputvalue(nextProps.selectedOptionValue, nextProps.id)
        this.props.setFieldValidtionState(nextProps.id, 'valid');
        this.setState({ setValue: true });
      }
    }
  }

  filterList = (event) => {
    var query = event.target.value;
    if (this.props.filterList !== undefined) {

      if (this.props.mandatory === "true") {
        if (query === "" || query === undefined || query !== this.state.selectedOptionValue) {
          this.props.setFieldValidtionState(this.props.id, 'invalid');
        }
      }
      this.props.filterList(event);
    }
    this.setState({ selectedOptionValue: query });
  }

  setSelectedOptions = (event, data, name) => {
    this.setState({ selectedOptionValue: data.email || '' });
    this.props.setInputvalue(data.email || data, name);
    this.props.setSelectedOptions(data, name);
    if (this.props.mandatory === "true") {
      if (data !== "") {
        this.props.setFieldValidtionState(name, 'valid');
      }
    }
  }


  render() {

    const options = (
      <List role="option" addText={this.translations(this.props.addText)} aria-selected="true" tabIndex="0" items={this.state.options} _setSelectedOptions={(event, entity) => this.setSelectedOptions(event, entity, this.props.id)} />
    );

    return (
      <div className="customersearchcont">
        <div className="searchboxdata">
          <input type="text" tabIndex="0"
            maxLength={this.props.maxLength}
            id={this.props.id}
            onChange={this.filterList}
            value={this.state.selectedOptionValue}
            readOnly={this.props.disabled}
            className="form-control form-control-lg" />
          <span className="verticalLine"></span>
          <span className="icon icon-search serachicon"></span>
        </div>
        <div id="searchId" className="optionList" role="dropdown">
          {this.state.showOptions ? options : ''}
        </div>
      </div>
    );
  }
}

const List = (props) => (
  <div className="listContent" id="setList">
    {
      props.items.map((item, index) => (<div className="listdata" key={index}>
        <div className="searchListdata"
          data-category={item.resolveError}
          tabIndex="0"
          onClick={(event) => props._setSelectedOptions(event, item)}>
          {item.email !== undefined ? item.email : ''}
        </div>
        <div className="divide"></div>
      </div>))
    }
    <div className="searchListother"
      tabIndex="0"
      onClick={(event) => props._setSelectedOptions(event, props.addText)}>
      {props.addText}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/SearchBox/index.js